import { useQuery } from "@tanstack/react-query";
import { applicationsApi, ApplicationDecision } from "api/applications";

export const useApplicationDecision = (
  applicationId: string | number | undefined
) =>
  useQuery<ApplicationDecision>({
    queryKey: ["APPLICATION", String(applicationId), "decision"],
    queryFn: () =>
      applicationsApi.getApplicationDecision(String(applicationId)),
    enabled: !!applicationId
  });
